// Fliken Tjänster: tabellen per period och panelen där en tjänst ändras
// (designen Admin-Katalog och Admin-Katalog-Timpris).
import { useState } from 'react';
import { Link } from 'react-router';
import type { Service } from '../../katalog/texter.js';
import { gallerText, PERIODER, prisText, prissattningText } from '../../katalog/texter.js';
import { formFran, tomForm, type TjanstForm } from '../../katalog/tjanstform.js';
import { TjanstPanel } from './TjanstPanel.js';
import { useKatalogKontext } from './Katalog.js';

type Val = { slag: 'tjanst'; id: string } | { slag: 'ny' } | null;

export function Tjanster() {
  const { katalog, kanAndra } = useKatalogKontext();
  const [val, setVal] = useState<Val>(null);
  const [andrad, setAndrad] = useState(false);

  function valj(nytt: Val) {
    if (andrad && !window.confirm('Du har ändringar som inte är sparade. Vill du lämna dem?')) {
      return;
    }
    setAndrad(false);
    setVal(nytt);
  }

  const vald = val?.slag === 'tjanst' ? katalog.services.find((s) => s.id === val.id) : undefined;
  const form: TjanstForm | null = val?.slag === 'ny' ? tomForm() : vald ? formFran(vald) : null;
  const panelNyckel = val?.slag === 'ny' ? 'ny' : (vald?.id ?? 'ingen');

  return (
    <div className={`tjanster${form ? ' med-panel' : ''}`}>
      <div className="kort tabellkort">
        {katalog.services.length === 0 ? (
          <div className="tom">
            <p>
              Katalogen har inga tjänster än.
              {kanAndra && ' Lägg till den första tjänsten, eller börja från en startmall.'}
            </p>
            {kanAndra && (
              <Link className="btn btn-s" to="/kom-igang">
                Välj startmall
              </Link>
            )}
          </div>
        ) : (
          <table className="tabell dolj-pa-mobil">
            <caption className="visuellt-dold">Tjänsterna i katalogen</caption>
            <thead>
              <tr>
                <th scope="col">Tjänst</th>
                <th scope="col">Prissättning</th>
                <th scope="col" className="hoger">
                  Pris exkl. moms
                </th>
                <th scope="col">Gäller</th>
              </tr>
            </thead>
            {PERIODER.map((period) => {
              const rader = katalog.services.filter((s) => s.billing === period.kod);
              if (rader.length === 0) return null;
              return (
                <tbody key={period.kod}>
                  <tr className="grupp">
                    <th scope="colgroup" colSpan={4}>
                      {period.grupp}
                    </th>
                  </tr>
                  {rader.map((s) => (
                    <Rad
                      key={s.id}
                      tjanst={s}
                      vald={vald?.id === s.id}
                      onVal={() => valj({ slag: 'tjanst', id: s.id })}
                    />
                  ))}
                </tbody>
              );
            })}
          </table>
        )}
        {kanAndra && (
          <div className="tabellfot">
            <button type="button" className="btn btn-g" onClick={() => valj({ slag: 'ny' })}>
              Lägg till tjänst
            </button>
          </div>
        )}
      </div>
      {form && (
        <TjanstPanel
          key={panelNyckel}
          start={form}
          onAndrad={setAndrad}
          onStang={() => valj(null)}
          onSparad={(id) => {
            setAndrad(false);
            setVal(id === null ? null : { slag: 'tjanst', id });
          }}
        />
      )}
    </div>
  );
}

function Rad({ tjanst, vald, onVal }: { tjanst: Service; vald: boolean; onVal: () => void }) {
  return (
    <tr className={vald ? 'vald' : undefined}>
      <td>
        <button type="button" className="radknapp" aria-pressed={vald} onClick={onVal}>
          {tjanst.label}
        </button>
        {tjanst.includes && tjanst.includes.length > 0 && (
          <div className="hjalp">{tjanst.includes.join(', ')}</div>
        )}
      </td>
      <td>{prissattningText(tjanst.pricing)}</td>
      <td className="mono hoger">{prisText(tjanst.pricing)}</td>
      <td>{gallerText(tjanst)}</td>
    </tr>
  );
}
